<template>
  <div class="status-list scroll-styling rounded-lg inl-100">
    <div class="relative overflow-x-auto">
        
        <AddThemeModal
            v-if="openModal && canEdit"
            :themeUUID="modalData.uuid"
            :course="modalData.course"
            :index="modalData.index"
            :prevTitle="modalData.prevTitle"
        />

        <RemoveThemeModal
            v-if="deleteModal && canEdit"
            :course="cureentCourse"
            :uuid="deleteUUID"
            :modalClose="() => {this.deleteModal = false;}"
        />

        <div class="text-center mb-2">
            <h2 class="font-semibold text-lg light mb-3">{{ navData.title }}</h2>
            <div v-if="userTotal !== null" class="mb-3">
                <h2 class="text-lg light mb-2">
                    Ваш итоговый балл - <span class="font-semibold"><b>{{ userTotal }}</b></span>
                </h2>
                <router-link
                  :to="'/client/certificate/' + this.$route.params.uuid"
                  v-slot="{ href, navigate }"
                >
                    <button
                        :href="href"
                        @click="navigate"
                        class='px-6 py-2 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150'
                        type="button">
                        <span>Получить сертификат</span>
                    </button>
                </router-link>
            </div>
            <div v-if="noActiveApplication">
                <p class="text-red-600 text-sm mb-2">
                    Доступ к курсу закрыт: нет активной одобренной заявки. Подайте заявку повторно.
                </p>
                <router-link
                  :to="'/client/courses/'"
                  v-slot="{ href, navigate }"
                >
                    <button
                        :href="href"
                        @click="navigate"
                        class='px-6 py-2 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150'
                        type="button">
                        <span>Подать заявку повторно</span>
                    </button>
                </router-link>
            </div>
            <div v-else-if="userLvl == -1 && attemptsUsed < maxAttempts">
                <p class="text-red-600 text-sm mb-2">
                    У вас осталось {{ maxAttempts - attemptsUsed }} попыток для повторного прохождения курса.
                </p>
                <router-link
                  :to="'/client/courses/'"
                  v-slot="{ href, navigate }"
                >
                    <button
                        :href="href"
                        @click="navigate"
                        class='px-6 py-2 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150'
                        type="button">
                        <span>Подать заявку повторно</span>
                    </button>
                </router-link>
            </div>
            <div v-else-if="userLvl == -1 && attemptsUsed >= maxAttempts">
                <p class="text-red-600 font-bold text-sm">Попытки исчерпаны ({{ attemptsUsed }} из {{ maxAttempts }})</p>
                <p class="text-gray-600 text-sm mt-1">Свяжитесь с модератором для сброса попыток и уточнения условий повторного прохождения.</p>
            </div>
        </div>
        <div class="mt-5 flex-center inl-100">
            <div class="relative max-w-md w-full">
                <input
                    class="w-full h-10 pl-10 pr-4 py-1 text-base placeholder-gray-500 border rounded-full focus:shadow-outline"
                    type="search" v-model="filterVal" @change="filterVals" placeholder="Поиск">
            </div>
            <button
                v-if="canEdit"
                class='px-6 py-2 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                @click="addModalEnd"
                type="button">
                <span>Создать</span>
            </button>
        </div>

        <div class="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg">
            <div class="table-container inl-100 tsor-table ">
                <div class="table-row header br-n bn-t">
                    <div style="width: 10%;" class="row-item bt-n bb-n br-r text-center">
                        <span class='px-6 py-2'>#</span>
                    </div>
                    <div :style="{ width: !canEdit ? '75%' : '55%' }" class="row-item bt-n bb-n br-r">
                        <span class='px-6 py-2'>Заголовок</span>
                    </div>
                    <div v-if="user.role.key === 2 && canEdit" style="width: 10%;" class="row-item bt-n bb-n br-r text-center">
                        <span class='px-6 py-2'>Статус</span>
                    </div>
                    <div style="width: 15%;" class="row-item bt-n bb-n">
                        <span class='px-6 py-2'>Открыть</span>
                    </div>
                    <div v-if="canEdit" style="width: 15%;" class="row-item bt-n bb-n text-center center">
                        <span class='px-6 py-2'>Действие</span>
                    </div>
                    <div v-if="[0,3].includes(user.role.key)" style="width: 15%;" class="row-item bt-n bb-n br-r text-center">
                        <span class='px-6 py-2 center'>Активировать</span>
                    </div>
                </div>

                <div
                    v-if="canEdit && tableDataFilter.length > 0" >
                    <draggable 
                        v-model="tableDataFilter" 
                        v-bind="dragOptions"
                        item-key="id"
                        @start="drag = true" 
                        @end="drag = false"
                        @update="onUpdate"
                        >
                        <template
                            #item="{ element, index }">
                            <TsorRowSingle 
                                @updateStatus="onUpdateStatus"
                                :userRole="user.role.key"
                                :userLvl="userLvl"
                                :canEdit="canEdit"
                                :element="element"
                                :index="index"
                                :setIndex="setIndex"
                                :updateModal="updateModal"
                                :openDeleteModal="openDeleteModal"
                            />
                        </template>
                    </draggable>
                </div>
                <div v-else>
                    <div v-for="(element, index) in tableDataFilter" :key="index">
                        <TsorRowSingle 
                            @updateStatus="onUpdateStatus"
                            :userRole="user.role.key"
                            :userLvl="userLvl"
                            :canEdit="canEdit"
                            :element="element"
                            :index="index"
                            :setIndex="setIndex"
                            :updateModal="updateModal"
                            :openDeleteModal="openDeleteModal"
                        />
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>
</template>

<script>

import axios from 'axios';
import { mapState } from 'vuex';
import { API_CLIENT, HEADERS_TOKEN_JSON } from '@/const/uri';
import  TsorRowSingle from '@/components/Tsor/TsorRowSingle.vue';
import VueDraggableNext from 'vuedraggable';
import AddThemeModal from '@/components/Tsor/AddThemeModal.vue';
import RemoveThemeModal from '@/components/Tsor/RemoveThemeModal.vue';

export default {
    components: {
        draggable: VueDraggableNext,
        TsorRowSingle,
        AddThemeModal, RemoveThemeModal,
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }, 
        ...mapState(['user',]),
    },
    data() {
        return {
            modalData: {
                uuid: null,
                course: null,
                index: null,
                prevTitle: null,
                id: null,
            },
            deleteModal: false,
            deleteUUID: null,
            openModal: false,
            tableDataFilter: [],
            tableData: [],
            courses: [1, 2, 3, 4],
            tableKeys: [],
            tableKeyStr: [],
            filterVal: null,
            cureentCourse: 1, 
            navData: {},
            canEdit: false,
            userLvl: 1,
            userTotal: null,
            attemptsUsed: 0,
            maxAttempts: 4,
            noActiveApplication: false,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        onUpdateStatus({uuid, is_confirmed}) {
            const el = this.tableDataFilter.find(x => x.uuid === uuid);
            console.log(el, is_confirmed);
            if (el) el.is_confirmed = is_confirmed;
        },
        openDeleteModal(id) {
            this.deleteUUID = id;
            this.deleteModal = true; 
        }, 
        deleteData(index) {
            this.tableData.splice(index-1, 1);
            this.deleteModal = false;
            location.reload();
        },
        updateModal(uuid, index, prevTitle,) { 
            this.modalData = {
                course: this.cureentCourse,
                index: index,
                prevTitle: prevTitle,
                uuid,
            };
            this.openModal = true;
        }, 
        addModalEnd() {
            this.modalData = {
                course: this.cureentCourse,
                index: null,
                prevTitle: null, 
                id: null,
            };
            this.openModal = true;
        }, 
        async onUpdate(e) {
            const newIndex = e.newIndex; 
            const oldIndex = e.oldIndex;
            await axios({
                method: "POST",
                data: {
                    old_index: oldIndex,
                    new_index: newIndex, 
                    course: this.cureentCourse,
                },
                url: API_CLIENT.tsorThemes + this.$route.params.uuid + '/index/',
                headers: HEADERS_TOKEN_JSON(),
            }).then((e) => {
                console.log(e);
            }).catch(function (e) {
                console.log(e);
            });
        },
        changeCourse(course) {
            this.cureentCourse = course;
            this.getData();
        },
        filterVals(e) {
            const val = e.target.value;
            if (!val || val == '') {
                this.tableDataFilter = [...this.tableData];
            }
            const regex = new RegExp(val.toLowerCase());
            const data = this.tableData.filter((obj) => regex.test(obj.title.toLowerCase()));
            this.tableDataFilter = data;
        },
        closeModal() {
            this.openModal = false;
        }, 
        updateData(obj) {
            const index = obj.index;
            const nObj = {
                id: obj.id,
                uuid: obj.uuid,
                title: obj.title,
                course: obj.course,
                index: obj.index,
            }; 
            if(obj.is_create ) {
                if(this.tableData.length < index) {
                    this.tableData.push({...nObj});
                } else {
                    this.tableData.splice(index-1, 0, {...nObj});                    
                }
            } else {
                this.tableData[index-1] = obj;
            }
        },
        setIndex(uuid) {
            this.$router.push({
                name: 'ClienntTsorTheme',
                params: {
                    themeUUID: uuid,
                    uuid: this.$route.params.uuid,
                }
            });
        },
        async getData() {
            await axios({
                method: "GET",
                params: {
                    uuid: this.$route.params.uuid,
                },
                url: API_CLIENT.tsorThemes,
                headers: HEADERS_TOKEN_JSON(),
            }).then((e) => {
                this.navData = e.data.data.nav_data;
                this.tableKeyStr = e.data.data.keys_str;
                this.tableKeys = e.data.data.keys;
                this.tableData = e.data.data.table_data;
                this.tableDataFilter = e.data.data.table_data;
                this.userLvl = e.data.data.user_lvl;
                this.userTotal = e.data.data.user_total;
                this.cureentCourse = e.data.data.course_uuid;
                this.canEdit = e.data.data.can_edit || false;
                this.attemptsUsed = e.data.data.attempts_used || 0;
                this.maxAttempts = e.data.data.max_attempts || 4;
                this.noActiveApplication = e.data.data.no_active_application || false;
            }).catch((e) => {
                console.log(e);
            });
        },
    },
    props: {
        navObj: {},
        isCanChange: {
            default: true,
        },
    }

}
</script>